import "../../../static/js/loaders/jquery";
$('.link-block.linked').on('click', function (event) {
    event.preventDefault();
    if ($('a', this).attr('target') === '_blank') {
        window.open($('a', this).attr('href'), '_blank')
    }
    else {
        var linkTarget = $(this).data('link');
        if (linkTarget) {
            window.location = linkTarget;
        } else {
            window.location = $('a', this).attr('href');
        }
    }
});

$('.video-modal').each(function () {
    var height = Number($('iframe', this).attr('height'));
    var width = Number($('iframe', this).attr('width'));

    if (width > height) {
        var ratio = height / width;

        $('.video-wrapper', this).css('padding-top', (ratio * 100) + '%');
    }

});

$('.video-modal').on('hidden.bs.modal', function (event) {
    var src = $('iframe', this).attr('src');

    $('iframe', this).attr('src', src);
});
